(function refillBuilder(){
  const path = window.location.pathname.replace(/\/$/, '');
  if (path !== '/products/arc-buffer-refill-packs') return;
  const variants = [
    { id: 46537444720837, label: 'Step 1 SHAPE', grit: '#220', sku: 'MA-BU-02', upc: '810142057219' },
    { id: 46537451929797, label: 'Step 2 GRIND', grit: '#320', sku: 'MA-BU-03', upc: '810142057226' },
    { id: 46537451962565, label: 'Step 3 SMOOTH', grit: '#600', sku: 'MA-BU-04', upc: '810142057233' },
    { id: 46537451995333, label: 'Step 4 SHINE', grit: '#3200', sku: 'MA-BU-05', upc: '810142057240' }
  ];
  const unitPrice = 4.99;
  const money = (value) => '$' + value.toFixed(2);
  function buildRows() {
    return variants.map((variant) => `
      <div class="mana-refill-row" data-variant-id="${variant.id}">
        <div class="mana-refill-row__label">
          <strong>${variant.label}</strong>
          <span>${variant.grit} / ${money(unitPrice)} each</span>
        </div>
        <div class="mana-refill-row__qty-wrap">
          <input class="mana-refill-row__qty" type="number" min="0" step="1" inputmode="numeric" value="0" aria-label="Quantity for ${variant.label}">
          <div class="mana-refill-row__identifier" aria-label="SKU ${variant.sku}; UPC ${variant.upc}">${variant.sku} <span aria-hidden="true">·</span> ${variant.upc}</div>
        </div>
        <div class="mana-refill-row__line" aria-live="polite">$0.00</div>
      </div>`).join('');
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  ready(() => {
    if (document.querySelector('[data-mana-refill-builder]')) return;
    const details = document.querySelector('[data-testid="product-information-details"]') || document.querySelector('.product-details');
    const defaultButtons = document.querySelector('.buy-buttons-block');
    if (!details || !defaultButtons) return;
    defaultButtons.style.display = 'none';
    document.querySelectorAll('variant-picker, .variant-picker').forEach((node) => {
      node.style.display = 'none';
    });
    details.querySelectorAll(':scope > .group-block, :scope > .group-block .group-block').forEach((node) => {
      if (node.style.display === 'none') node.style.display = '';
    });
    const builder = document.createElement('section');
    builder.className = 'mana-refill-builder';
    builder.setAttribute('data-mana-refill-builder', '');
    builder.innerHTML = `
      <div class="mana-refill-builder__head">
        <h2>Refill Strip Packs</h2>
        <p>Enter quantities below. Each strip is $4.99.</p>
      </div>
      <div class="mana-refill-builder__rows">${buildRows()}</div>
      <div class="mana-refill-builder__footer">
        <div class="mana-refill-builder__total">Total <strong>$0.00</strong></div>
        <button type="button" class="button mana-refill-builder__button" disabled>Add selected strips</button>
      </div>
      <p class="mana-refill-builder__status" role="status" aria-live="polite"></p>`;
    defaultButtons.parentNode.insertBefore(builder, defaultButtons);
    const inputs = Array.from(builder.querySelectorAll('.mana-refill-row__qty'));
    const totalNode = builder.querySelector('.mana-refill-builder__total strong');
    const button = builder.querySelector('.mana-refill-builder__button');
    const status = builder.querySelector('.mana-refill-builder__status');
    const shippingWidget = defaultButtons.querySelector('[data-mana-fast-shipping]');
    if (shippingWidget) builder.insertBefore(shippingWidget, builder.querySelector('.mana-refill-builder__footer'));
    function readQty(input) {
      const qty = Math.max(0, Math.floor(Number(input.value) || 0));
      input.value = String(qty);
      return qty;
    }
    function update() {
      let totalQty = 0;
      let total = 0;
      inputs.forEach((input) => {
        const row = input.closest('.mana-refill-row');
        const qty = readQty(input);
        const line = qty * unitPrice;
        totalQty += qty;
        total += line;
        row.querySelector('.mana-refill-row__line').textContent = money(line);
      });
      totalNode.textContent = money(total);
      button.disabled = totalQty === 0;
      status.textContent = totalQty === 0 ? 'Quantity starts at 0.' : `${totalQty} strip${totalQty === 1 ? '' : 's'} selected.`;
    }
    inputs.forEach((input) => input.addEventListener('input', update));
    update();
    button.addEventListener('click', async () => {
      const items = inputs.map((input) => ({
        id: Number(input.closest('.mana-refill-row').dataset.variantId),
        quantity: readQty(input)
      })).filter((item) => item.quantity > 0);
      if (!items.length) return;
      button.disabled = true;
      button.textContent = 'Adding...';
      status.textContent = '';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(await response.text());
        button.textContent = 'Added';
        status.textContent = 'Selected refill strips added to cart.';
        document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        setTimeout(() => { button.textContent = 'Add selected strips'; update(); }, 1800);
      } catch (error) {
        button.textContent = 'Add selected strips';
        status.textContent = 'Could not add strips. Try again.';
        update();
      }
    });
  });
})();

(function () {
  const successMessage = 'Thanks for reaching out, we will be in touch.';
  const sendingMessage = 'Submitting your message...';
  const emailMessage = 'Please enter your email before submitting.';

  function injectStyles() {
    if (document.getElementById('manacare-contact-submit-feedback-20260724-asset')) return;
    const style = document.createElement('style');
    style.id = 'manacare-contact-submit-feedback-20260724-asset';
    style.textContent = `
      .contact-form__form .mana-contact-status {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0 0 2px;
        padding: 14px 16px;
        border: 1px solid rgba(193, 118, 63, 0.58);
        background: rgba(193, 118, 63, 0.12);
        color: currentColor;
        font-weight: 800;
        line-height: 1.35;
      }
      .contact-form__form .mana-contact-status[hidden] { display: none; }
      .contact-form__form .mana-contact-status[data-tone='error'] {
        border-color: rgba(210, 71, 54, 0.72);
        background: rgba(210, 71, 54, 0.12);
      }
    `;
    document.head.appendChild(style);
  }

  function ensureStatus(form) {
    let status = form.querySelector('.mana-contact-status');
    if (status) return status;
    status = document.createElement('div');
    status.className = 'mana-contact-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    form.insertBefore(status, form.firstElementChild);
    return status;
  }

  function showStatus(form, message, tone = 'info') {
    const status = ensureStatus(form);
    status.textContent = message;
    status.dataset.tone = tone;
    status.hidden = false;
  }

  function wireForm(form) {
    if (!form || form.dataset.manaContactFeedback === 'ready') return;
    form.dataset.manaContactFeedback = 'ready';

    const email = form.querySelector('input[name="contact[email]"]');
    if (email) email.required = true;

    form.addEventListener('submit', () => {
      if (email && !email.value.trim()) {
        showStatus(form, emailMessage, 'error');
        return;
      }

      showStatus(form, sendingMessage);
      const button = form.querySelector('button[type="submit"], input[type="submit"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        if (button.tagName === 'BUTTON') button.textContent = 'Submitting...';
      }
    });
  }

  function init() {
    const forms = Array.from(document.querySelectorAll('form[action^="/contact"], form.contact-form__form'));
    if (!forms.length) return;
    injectStyles();
    forms.forEach(wireForm);

    const target = forms[0];
    if (target && (document.querySelector('.contact-form__success') || window.location.search.includes('contact_posted=true'))) {
      showStatus(target, successMessage, 'success');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
